import { FeedbackModal, FeedbackModalConfig } from 'components/feedback/FeedbackModal'
import React from 'react'
import { ADA_CHAT_NEGATIVE_FEEDBACK_OPTIONS, ADA_CHAT_POSITIVE_FEEDBACK_OPTIONS } from './constants'

interface AdaChatFeedbackModalProps {
  open: boolean
  onClose: () => void
}

export const AdaChatFeedbackModal: React.FC<AdaChatFeedbackModalProps> = ({ open, onClose }) => {
  const config: FeedbackModalConfig = {
    title: 'Leave Feedback',
    questionText: 'How would you rate your overall experience with Ada Chat?',
    thumbsUpTooltip: "I'm satisfied with Ada Chat",
    thumbsDownTooltip: 'Ada Chat could be improved',
    positiveFeedbackOptions: ADA_CHAT_POSITIVE_FEEDBACK_OPTIONS,
    negativeFeedbackOptions: ADA_CHAT_NEGATIVE_FEEDBACK_OPTIONS,
    customFeedbackPlaceholder: 'Tell us more about what could be improved...',
    successTitle: 'Thank you for your feedback!',
    successMessage: 'Your feedback helps us improve Ada Chat.',
    closeButtonText: 'Close',
  }

  return (
    <FeedbackModal
      open={open}
      onClose={onClose}
      config={config}
      feedbackOptions={{
        featureType: 'ada_chat',
        thumbsUpBehavior: 'submitSilentlyAndShowChips',
        thumbsDownBehavior: 'submitSilentlyAndShowChips',
        onError: (error) => {
          console.error('Ada Chat feedback submission error:', error)
        },
      }}
    />
  )
}
